import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table, Radio, Input, Button, Icon } from "antd";
import styles from "./IndretTaula.module.css";
import {
  paginacioPerDefecte,
  ordenarAttribut,
  obtenirEstatPerDefecte,
  seleccionarPaginacio
} from "../commons/TaulaOrdenacioCerca";
import { esborrarIndretSeleccionat, canviTextCercaVista } from "../../actions";
import { rutaDetallIndret } from "../../routes";
import { TEXT_QUAN_NO_HI_HA_DADA } from "../../constantsFormularis";
import { getCercaVistes } from "../../reducers";

const columnaNomObservador = "nomObservador";
const columnaNomIndret = "nom";
const columnaPaisatge = "paisatge";
const columnaClima = "clima";
const columnaDistanciaMar = "distanciaMar";
const columnaRelleu = "relleu";
const columnaOrientacio = "orientacio";
const columnaEstat = "estat";

// Aquesta parametrització de columnes està relacionada amb el mètode obtenirConfiguracioColumnes()
const columnesAmbFiltres = [
  columnaNomObservador,
  columnaNomIndret,
  columnaPaisatge,
  columnaClima,
  columnaDistanciaMar,
  columnaRelleu,
  columnaOrientacio,
  columnaEstat
];

class IndretTaula extends Component {
  constructor(props) {
    super(props);
    const { indrets } = props;
    this.state = obtenirEstatPerDefecte(indrets, columnesAmbFiltres);
  }

  componentDidMount() {
    this.props.esborrarIndretSeleccionat();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.indrets !== nextProps.indrets) {
      const { indrets } = nextProps;
      this.setState(() => obtenirEstatPerDefecte(indrets, columnesAmbFiltres));
    }
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Cerca...`}
          value={selectedKeys && selectedKeys[0] ? selectedKeys[0] : null}
          onChange={e => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => {
            this.handleSearch(selectedKeys, confirm, dataIndex);
            this.props.canviTextCercaVista(selectedKeys[0], dataIndex);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => {
            this.handleSearch(selectedKeys, confirm, dataIndex);
            this.props.canviTextCercaVista(selectedKeys[0], dataIndex);
          }}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            this.handleReset(clearFilters);
            this.props.canviTextCercaVista("", "");
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  obtenirConfiguracioColumnaOrdenadaIFiltrada(
    nom,
    item,
    tipus,
    amplada,
    valorFilter
  ) {
    return {
      title: nom,
      width: amplada ? amplada : 150,
      dataIndex: item,
      key: item,
      filteredValue: valorFilter ? [valorFilter] : null,
      sorter: (itemA, itemB) => ordenarAttribut(itemA, itemB, item, tipus),
      render: text => text || TEXT_QUAN_NO_HI_HA_DADA,
      ...this.getColumnSearchProps(item)
    };
  }

  obtenirConfiguracioColumnes(cercaVistes) {
    return [
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Indret",
        columnaNomIndret,
        null,
        250,
        cercaVistes.columnaCerca === columnaNomIndret
          ? cercaVistes.textCerca
          : null
      ),

      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Observador",
        columnaNomObservador,
        null,
        200,
        cercaVistes.columnaCerca === columnaNomObservador
          ? cercaVistes.textCerca
          : null
      ),

      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Paisatge",
        columnaPaisatge,
        null,
        200,
        cercaVistes.columnaCerca === columnaPaisatge
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Clima",
        columnaClima,
        null,
        200,
        cercaVistes.columnaCerca === columnaClima ? cercaVistes.textCerca : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Dist. mar",
        columnaDistanciaMar,
        "number",
        130,
        cercaVistes.columnaCerca === columnaDistanciaMar
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Relleu",
        columnaRelleu,
        null,
        240,
        cercaVistes.columnaCerca === columnaRelleu
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Orientació",
        columnaOrientacio,
        null,
        140,
        cercaVistes.columnaCerca === columnaOrientacio
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Estat",
        columnaEstat,
        null,
        105,
        cercaVistes.columnaCerca === columnaEstat ? cercaVistes.textCerca : null
      )
    ];
  }

  onClickIndret(idIndret) {
    const { history, getDadesIndretSeleccionat } = this.props;
    getDadesIndretSeleccionat(idIndret);
    history.push({
      pathname: rutaDetallIndret
    });
  }

  render() {
    const { paginacio } = this.state;
    const { cercaVistes } = this.props;
    const mostrarSelectorPaginacio =
      this.state.data.length > 0 ? "block" : "none";

    return (
      <div className={styles.indretTaula}>
        <Table
          dataSource={this.state.data}
          columns={this.obtenirConfiguracioColumnes(cercaVistes)}
          pagination={{ pageSize: paginacio, position: "bottom" }}
          bordered
          scroll={{ x: "max-content", y: 600 }}
          size="middle"
          onRow={record => ({
            onClick: () => {
              this.onClickIndret(parseInt(record.id, 0));
            }
          })}
          rowKey={record => record.id}
        />
        <Radio.Group
          className={styles.observadorTaulaSelectorPaginacio}
          size="small"
          onChange={event =>
            seleccionarPaginacio(event.target.value, this.setState.bind(this))}
          style={{ display: mostrarSelectorPaginacio }}
          value={paginacio}
        >
          <Radio.Button value={paginacioPerDefecte}>
            {paginacioPerDefecte}
          </Radio.Button>
          <Radio.Button value={40}>40</Radio.Button>
          <Radio.Button value={60}>60</Radio.Button>
          <Radio.Button value={100}>100</Radio.Button>
        </Radio.Group>
      </div>
    );
  }
}

IndretTaula.propTypes = {
  onClickIndret: PropTypes.func,
  indrets: PropTypes.arrayOf(
    PropTypes.shape({
      nom: PropTypes.string
    })
  ),
  history: PropTypes.object,
  getDadesIndretSeleccionat: PropTypes.func,
  esborrarIndretSeleccionat: PropTypes.func,
  canviTextCercaVista: PropTypes.func,
  cercaVistes: PropTypes.object
};

const mapStateToProps = state => {
  return {
    cercaVistes: getCercaVistes(state)
  };
};

const mapDispatchToProps = {
  esborrarIndretSeleccionat,
  canviTextCercaVista
};

export default connect(mapStateToProps, mapDispatchToProps)(IndretTaula);
